import { render, staticRenderFns } from "./Virtual.vue?vue&type=template&id=5fb8c7a3&scoped=true&"
import script from "./Virtual.vue?vue&type=script&lang=js&"
export * from "./Virtual.vue?vue&type=script&lang=js&"
import style0 from "./Virtual.vue?vue&type=style&index=0&id=5fb8c7a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8c7a3",
  null
  
)

export default component.exports